import { cn } from '@nexelem/utils';
import { cva, VariantProps } from 'class-variance-authority';
import { PropsWithChildren } from 'react';

const singleDetailLabelVariants = cva('', {
  variants: {
    size: {
      default: 'px-2 py-1 text-t14-sb text-text-secondary',
      big: 'p-2 text-t16-b',
      jumbo: 'px-2 py-1 text-t20-sb text-text-secondary',
    },
    noSidePadding: {
      true: 'px-0',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

type SingleDetailsLabelVariants = VariantProps<typeof singleDetailLabelVariants>;

type SingleDetailLabelProps = SingleDetailsLabelVariants & {
  className?: string;
};

export const SingleDetailLabel = ({
  children,
  size,
  noSidePadding,
  className,
}: PropsWithChildren<SingleDetailLabelProps>) => (
  <div className={cn(singleDetailLabelVariants({ size, noSidePadding }), className)}>{children}</div>
);
